<app-breadcrumb
  [title]="'Преглед на аварии'"
  [items]="['Аварии']"
  [active_item]="'Списък аварии'"
>
</app-breadcrumb>

<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div class="card card-reset">

    <!-- Card header -->
    <div class="card-header">
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row justify-content-between">
            <div>
              <app-toggle-btn
                [objects]="viewToggleOptions"
                [bindProperty]="'value'"
                [currentlySelectedObject]="currentlySelectedView"
                (clicked)="onViewChange($event)"
              ></app-toggle-btn>
            </div>
            <div class="d-flex flex-row gap-3">
              <button *ngIf="isUserRepairGroupManager"
                type="button"
                class="btn btn-success btn-sm"
                [disabled]="!unconvertedRegisteredSignalsList?.length"
                (click)="onAddNewEmergencyClicked()"
              >
                <i class="fa fa-plus"></i> Регистрирай авария
              </button>
              <button
                type="button"
                class="btn btn-light btn-sm"
                (click)="onToggleSearchFiltersClicked()"
              >
                <i class="fa fa-filter"></i> {{searchFiltersToggled ? 'Скрий филтрите': 'Покажи филтрите'}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="searchFiltersToggled" class="row mt-3">
        <div class="col">
          <app-emergency-filter-form
            [emergencyStatusesList]="emergencyStatusList"
            [initialFilter]="emergenciesSearchFilter"
            (filterClicked)="onFilterSignalsList($event)" >
          </app-emergency-filter-form>
        </div>
      </div>
    </div>

    <!-- Card body -->
    <div class="card-body">
      <ng-container *ngIf="isGridView">
        <table class="table table-sm table-reset table-hover">
          <thead>
            <tr>
              <th scope="col">Идентификатор</th>
              <th scope="col">Заглавие</th>
              <th scope="col">Тип авария</th>
              <th scope="col">Работна група</th>
              <th scope="col">Описание</th>
              <th scope="col">Статус</th>
              <th scope="col">Дата на подаване</th>
              <th scope="col" class="map-view-action-col">Място</th>
              <th scope="col" class="edit-action-col">Преглед</th>
              <th scope="col" class="edit-action-col">Редакция</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of filteredEmergenciesList">
              <tr>
                <td>{{e.id}}</td>
                <td>{{e.title}}</td>
                <td>{{e.tipAvaria.title}}</td>
                <td>{{e.workingGroups.title}}</td>
                <td>{{e.description}}</td>
                <td>{{getStatus(e)}}</td>
                <td>{{getSignalCheckoutDateTime(e.registeredSignalId) | date}}</td>
                <td class="map-view-action-col">
                  <button class="grid-btn btn-light btn btn-sm"
                          ngbTooltip="Натиснете тук за да визуализирате местоположението на сигнала в/у картата."
                          placement="top"
                          (click)="onToggleMapView(e)">
                    {{isLocationMapView(e) ? 'Скрий' : 'Покажи'}}
                  </button>
                </td>
                <td class="edit-action-col">
                  <button class="grid-btn btn btn-info btn-sm"
                          ngbTooltip="Натиснете тук за да прегледате аварията."
                          placement="top"
                          (click)="openReadOnlyEmergencyViewModal(e)">
                    <i class="fa fa-eye"></i>
                  </button>
                </td>
                <td class="edit-action-col">
                  <button *ngIf="canEditEmergency(e)" class="grid-btn btn btn-warning btn-sm"
                          ngbTooltip="Натиснете тук за да редактирате аварията."
                          placement="top"
                          (click)="onEmergencyEditClicked(e)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button style="display: none;"
                          class="grid-btn btn btn-danger btn-sm"
                          ngbTooltip="Натиснете тук за да редактирате сигнала."
                          placement="top"
                          (click)="onEmergencyEditClicked(e)">
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="isLocationMapView(e)" class="expandable-colspan-row">
                <td class="col-xs-12" [attr.colspan]="gridColsNum">
                  <app-map-location-selector
                    [location]="{lat: +e.latitude, lng: +e.longitude}"
                    [readonly]="true"
                    [focusView]="false"
                    [zoom]="16">
                  </app-map-location-selector>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>

      <ng-container *ngIf="isMapView">
        <app-emergencies-map-view
          [emergenciesList]="filteredEmergenciesList"
          [focusView]="true">
        </app-emergencies-map-view>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <app-loader text="Зареждане на списъка с аварии..."></app-loader>
</ng-template>
